import axios, { AxiosRequestConfig } from 'axios';
import { ResetPasswordCredentials, ResetPasswordEmailCredentials } from './types';

export const sendResetPasswordEmail = async (credentials: ResetPasswordEmailCredentials) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        // csrf-cookie
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/forgot-password`,
            credentials,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message:
                error.response.status === 404
                    ? 'O e-mail informado não consta em nosso sistema'
                    : 'Erro ao enviar link para redefinição de senha',
            error: error
        };

        console.error(response);

        return response;
    }
};

export const resetPassword = async (credentials: ResetPasswordCredentials) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        // csrf-cookie
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/reset-password`,
            credentials,
            requestConfig
        );

        return response.data;
    } catch (error) {
        const response = {
            message: 'Erro ao redefinir senha',
            error: error
        };

        console.error(response);

        return response;
    }
};
